var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandEventActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.6 14.8h8.8a.6.6 0 0 1 0 1.2H.6a.6.6 0 0 1 0-1.2zm7.219-7.875a.788.788 0 0 0-1.114 0l-1.92 1.921-.74-.74a.787.787 0 0 0-1.345.557v3.325c0 .349.265.612.59.612h3.348a.787.787 0 0 0 .556-1.344l-.74-.74 1.922-1.921a.787.787 0 0 0 0-1.114l-.557-.556zM15.387 0H12.04a.787.787 0 0 0-.556 1.344l.74.74-1.921 1.921a.788.788 0 0 0 0 1.114l.556.557a.787.787 0 0 0 1.114 0l1.92-1.922.74.74a.79.79 0 0 0 .859.17.784.784 0 0 0 .508-.749V.568C16 .264 15.737 0 15.387 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandEventActive);
export default __webpack_public_path__ + "static/media/expand-event-active.fb7cbf57ef6f175b28b5876682185988.svg";
export { ForwardRef as ReactComponent };